<div class="post-login-dept-dialog">

  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="dialog-title-group">
      <h2 mat-dialog-title id="post-login-dept-title" class="dialog-title">
        Department Configuration
      </h2>
      <p class="dialog-subtitle">
        <mat-icon aria-hidden="true">account_circle</mat-icon>
        {{ userEmail }}
      </p>
    </div>
    <!-- <button
      mat-icon-button
      type="button"
      class="dialog-close-btn"
      (click)="onSkip()"
      aria-label="Skip department selection and close dialog"
      matTooltip="Skip"
      matTooltipPosition="below">
      <mat-icon aria-hidden="true">clear</mat-icon>
    </button> -->
  </div>

  <mat-divider aria-hidden="true"></mat-divider>

  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-body">

    <form
      [formGroup]="departmentForm"
      novalidate
      aria-label="Department selection">

      <!-- Mode: Select existing department -->
      <ng-container *ngIf="!isAddingNewDepartment">

        <mat-form-field appearance="outline" class="full-width-field">
          <mat-label>Select Department</mat-label>
          <mat-select
            formControlName="team"
            cdkFocusInitial
            required
            aria-required="true"
            (selectionChange)="onchangeTeam($event)"
            (openedChange)="onSelectOpenedChange($event)"
            [attr.aria-describedby]="(departmentForm.get('team').invalid && departmentForm.get('team').touched) ? 'team-error' : null">
            <mat-option>
              <ngx-mat-select-search
                [formControl]="teamFilterCtrl"
                placeholderLabel="Search department..."
                noEntriesFoundLabel="No departments found">
              </ngx-mat-select-search>
            </mat-option>
            <ng-container *ngIf="userTeamList && userTeamList.length > 0; else noDepartments">
              <mat-option *ngFor="let team of filteredTeamList" [value]="team.id">
                {{ team.name }}
              </mat-option>
            </ng-container>
            <ng-template #noDepartments>
              <mat-option disabled>No departments available</mat-option>
            </ng-template>
          </mat-select>
          <mat-error id="team-error" role="alert">
            Please select a department
          </mat-error>
        </mat-form-field>

        <div class="add-new-trigger">
          <button
            mat-stroked-button
            type="button"
            color="primary"
            class="add-new-dept-btn"
            [disabled]="isLoading"
            (click)="toggleAddNewMode()"
            aria-label="Switch to create a new department">
            <mat-icon aria-hidden="true">add</mat-icon>
            Add New Department
          </button>
        </div>

      </ng-container>

      <!-- Mode: Add new department -->
      <ng-container *ngIf="isAddingNewDepartment">

        <div role="group" aria-label="Add new department">

          <mat-form-field appearance="outline" class="full-width-field">
            <mat-label>New Department Name</mat-label>
            <input
              matInput
              type="text"
              id="dept-name-input"
              formControlName="name"
              autocomplete="off"
              maxlength="25"
              cdkFocusInitial
              aria-describedby="name-char-count"
              (input)="onNameChange($event)">
            <mat-hint id="name-char-count" aria-live="polite">
              {{ nameLength }} / 25 characters used
            </mat-hint>
            <mat-error role="alert">Department name is required and cannot exceed 25 characters</mat-error>
          </mat-form-field>

          <button
            mat-button
            type="button"
            class="back-to-select-btn"
            (click)="toggleAddNewMode()"
            aria-label="Back to select an existing department">
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
            Back to Select Department
          </button>

        </div>

      </ng-container>

    </form>

  </mat-dialog-content>

  <mat-divider aria-hidden="true"></mat-divider>

  <!-- Dialog Actions -->
  <mat-dialog-actions class="dialog-actions" align="end">
    <!-- <button
      mat-stroked-button
      type="button"
      class="skip-btn"
      (click)="onSkip()"
      aria-label="Skip — assign a department later">
      SKIP
    </button> -->
    <button
      mat-raised-button
      color="primary"
      type="button"
      class="save-btn platform-login-button"
      (click)="onSave()"
      [disabled]="departmentForm.invalid || isLoading"
      [attr.aria-disabled]="(departmentForm.invalid || isLoading) ? 'true' : null"
      [attr.aria-label]="saveTooltip"
      [matTooltip]="saveTooltip"
      matTooltipPosition="above">
      <mat-icon aria-hidden="true">save</mat-icon>
      <span>SAVE &amp; CONTINUE</span>
    </button>
  </mat-dialog-actions>

</div>